import React from 'react'

import TableHeader from './header'
import './list.css'
import './table-column-sizes.css'

import RoundBlueButton from '../BorderButton/round-blue-button'

import Multi from '../../components/Multi'
import { formatNumber, getPercentage, numberWithCommas } from '../../lib/format-number'
import { isAdmin } from '../../lib/check-user'
import ReactTooltip from 'react-tooltip'

import LicenseList from '../../components/LicenseList'
import { getDmp, getDmpProduct, uniqueDmps } from '../../lib/format-dmps'
import ACLCheckPermission from '../ACLCheckPermission'

import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

import DMPFilter from '../../components/DMPFilter'

const DeleteButton = ({ onClick, disabled }) => (
    <RoundBlueButton data-tip data-for="deleteBtnTooltip" disabled={disabled} onClick={onClick} icon={<i className="fa fa-trash-o" />} />
)
const ImportButton = ({ onClick, disabled }) => (
    <RoundBlueButton data-tip data-for="importBtnTooltip" disabled={disabled} onClick={onClick} icon={<i className="fa fa-upload" />} />
)
const EditButton = ({ onClick, disabled }) => (
    <RoundBlueButton data-tip data-for="editBtnTooltip" disabled={disabled} onClick={onClick} icon={<i className="fa fa-pencil" />} />
)
const RequeueButton = ({ onClick, disabled }) => (
    <RoundBlueButton data-tip data-for="requeueBtnTooltip" disabled={disabled} onClick={onClick} icon={<i className="fa fa-refresh" />} />
)

export const AudienceSize = ({ size }) => (!isNaN(size) && size >= 1000 ? formatNumber(size) : <Multi>&lt; 1000</Multi>)

const renderItem = (
    audience,
    index,
    state,
    history,
    showEdit,
    showSelect,
    onSelect,
    onEdit,
    onImport,
    onHistory,
    onDelete,
    onLicenseDetail,
    onSizeDetail,
    onDmpChange,
    onSyncAudienceDetails,
    onRequeue,
    onSortDetailsChange
) => {
    const clickLicenseDetailsCallback = aud => {
        aud.showDetails = !aud.showDetails
        //this.setState({test: new Date().getTime() });
        // TODO: call eventDetails API
        if (aud.showDetails) onLicenseDetail(aud.audienceId)
    }
    const clickSizeDetailsCallback = aud => {
        aud.showSizeDetails = !aud.showSizeDetails
        //this.setState({test: new Date().getTime() });
        // TODO: call eventDetails API
        if (aud.showSizeDetails) onSizeDetail(aud.audienceId)
    }
    const clickSyncAudienceCallback = aud => {
        aud.syncAudienceDetails = !aud.syncAudienceDetails
        //this.setState({test: new Date().getTime() });
        // TODO: call eventDetails API
        if (aud.syncAudienceDetails) onSyncAudienceDetails(aud.audienceId)
    }

    const itemRows = [
        <tr
            key={'row-data-' + audience.audienceId}
            className={`audience-list audience-list--row }`}
            style={{ background: audience.deleted == 1 ? '#eee' : 'white' }}>
            {showSelect && (
                <td className="audience-list audience-list--size" style={{ color: audience.deleted == 1 ? '#bbb' : 'gray' }}>
                    <input
                        className="form-check-input"
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios1"
                        style={{ position: 'relative' }}
                        value="option1"
                        onClick={() => onSelect(audience)}
                    />
                </td>
            )}
            <td className="audience-list audience-list--audience" style={{ color: audience.deleted == 1 ? '#bbb' : 'gray' }}>
                {audience.audienceId} <br />
                {audience.alternativeId && (
                    <span style={{ 'font-size': '13px', 'color': '#56564c', 'fontStyle': 'italic', 'padding-top': '5px', }}>(Alt Id: {audience.alternativeId})</span>
                )}
            </td>
            {/*
            <td className="audience-list audience-list--audience" style={{ color: audience.deleted == 1 ? '#bbb' : 'gray' }}>
                {audience.alternativeId}
            </td>
            */}
            <td className="audience-list audience-list--audience" style={{ color: audience.deleted == 1 ? '#bbb' : 'gray' }}>
                {audience.audienceName} <br />

                {audience.description && (

                    <div style={{
                        color: audience.deleted == 1 ? '#bbb' : 'gray',
                        'font-size': '13px',
                        maxWidth: '450px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        'color': '#56564c',
                        'fontStyle': 'italic',
                        'padding-top': '5px',
                        'white-space': 'nowrap',

                    }}>
                        Description: {audience.description}
                    </div>

                )}

            </td>
            {/*
            <td
                className="audience-list audience-list--audience"
                style={{
                    color: audience.deleted == 1 ? '#bbb' : 'gray',
                    maxWidth: '250px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}>
                {audience.description}
            </td>
            */}

            <td className="audience-list audience-list--size" style={{ color: audience.deleted == 1 ? '#bbb' : 'gray' }}>
                {new Date(audience.creation).toDateString()}
            </td>

            <td className="audience-list audience-list--size" style={{ color: audience.deleted == 1 ? '#bbb' : 'gray' }}>
                <div>Cookie: <AudienceSize size={audience.sizeArCookie} /><br /></div>
                <div>Mobile: <AudienceSize size={audience.sizeArMobile} /><br /></div>
                {/*<div>Cross: <AudienceSize size={audience.sizeArCross} /><br/></div>*/}
            </td>

            <td className="audience-list audience-list--size" style={{ color: audience.deleted == 1 ? '#bbb' : 'gray' }}>
                <AudienceSize size={audience.sizeDdp} />
            </td>
            <td className="audience-list audience-list--size" style={{ color: audience.deleted == 1 ? '#bbb' : 'gray' }}>
                <AudienceSize size={audience.sizeAdform} />
            </td>

            {showEdit && (
                <td className="audience-list audience-list--edit" style={{ width: '20px' }}>
                    {audience.deleted != 1 && (
                        <div className="action-wrapper" style={{ justifyContent: 'flex-end' }}>
                            <ACLCheckPermission api="/audience" method="PATCH">
                                <ReactTooltip id="editBtnTooltip" type="dark" effect="solid">
                                    <span>Edit audience</span>
                                </ReactTooltip>
                                <EditButton onClick={() => onEdit(audience)} />
                            </ACLCheckPermission>
                            &#160;
                            <ACLCheckPermission api="/audience" method="DELETE">
                                <ReactTooltip id="deleteBtnTooltip" type="dark" effect="solid">
                                    <span>Delete audience</span>
                                </ReactTooltip>
                                <DeleteButton onClick={() => onDelete(audience)} />
                            </ACLCheckPermission>
                        </div>
                    )}
                </td>
            )}

            <td className="audience-list audience-list--edit">
                {audience.deleted != 1 && (
                    <div className="action-wrapper" style={{ justifyContent: 'flex-end' }}>
                        <ReactTooltip id="licenseBtnTooltip" type="dark" effect="solid">
                            <span>Show licenses for this audience</span>
                        </ReactTooltip>
                        <ReactTooltip id="sizeBtnTooltip" type="dark" effect="solid">
                            <span>Show size progression for this audience</span>
                        </ReactTooltip>
                        <ReactTooltip id="syncAudienceDetailsBtnTooltip" type="dark" effect="solid">
                            <span>Show syncs for this audience</span>
                        </ReactTooltip>
                        <ReactTooltip id="requeueBtnTooltip" type="dark" effect="solid">
                            <span>Requeue: Sync this audience</span>
                        </ReactTooltip>
                        <ACLCheckPermission api="/upload_notification" method="POST">
                            <ReactTooltip id="importBtnTooltip" type="dark" effect="solid">
                                <span>Import audience</span>
                            </ReactTooltip>
                            <ImportButton onClick={() => onImport(audience)} />
                        </ACLCheckPermission>
                        &#160;
                        {isAdmin() && <RequeueButton onClick={() => onRequeue(audience)} />}
                        &#160;
                        <RoundBlueButton
                            icon={<i className="fa fa-sitemap" />}
                            data-tip
                            data-for="licenseBtnTooltip"
                            type="button"
                            data-toggle="collapse"
                            data-target={'#licenseDetails' + audience.audienceId}
                            onClick={() => clickLicenseDetailsCallback(audience)}
                        />
                        &#160;
                        <RoundBlueButton
                            icon={<i className="fa fa-share" />}
                            data-tip
                            data-for="syncAudienceDetailsBtnTooltip"
                            type="button"
                            data-toggle="collapse"
                            data-target={'#syncAudience' + audience.audienceId}
                            onClick={() => clickSyncAudienceCallback(audience)}
                        />
                        &#160;
                        <RoundBlueButton
                            icon={<i className="fa fa-line-chart" />}
                            data-tip
                            data-for="sizeBtnTooltip"
                            type="button"
                            data-toggle="collapse"
                            data-target={'#sizeDetails' + audience.audienceId}
                            onClick={() => clickSizeDetailsCallback(audience)}
                        />
                    </div>
                )}
            </td>
        </tr>
    ]

    // license details
    if (state && state.licenseDetails) {
        itemRows.push(
            <tr
                key={'row-expanded-' + audience.audienceId}
                className={'collapse '}
                id={'licenseDetails' + audience.audienceId}
                style={{ borderTop: '1px solid #eee' }}>
                <td colSpan="6">
                    <div className="card card-body">
                        {!state.licenseDetailsLoading[audience.audienceId] &&
                            state.licenseDetails &&
                            state.licenseDetails[audience.audienceId] &&
                            state.licenseDetails[audience.audienceId].length == 0 && <span>No license found!</span>}
                        {state.licenseDetailsLoading[audience.audienceId] &&
                            state.licenseDetails &&
                            state.licenseDetails[audience.audienceId] &&
                            state.licenseDetails[audience.audienceId].length == 0 && <span>Loading...</span>}
                        {state.licenseDetails[audience.audienceId] && state.licenseDetails[audience.audienceId].length > 0 && (
                            <LicenseList
                                licenses={state.licenseDetails[audience.audienceId]}
                                onSortChange={sortField => onSortDetailsChange(sortField, audience.audienceId)}
                                onShowEdit={false}
                            />
                        )}
                    </div>
                </td>
            </tr>
        )
    }

    // license details
    if (state && state.syncAudienceDetails) {
        itemRows.push(
            <tr
                key={'sync-row-expanded-' + audience.audienceId}
                className={'collapse '}
                id={'syncAudience' + audience.audienceId}
                style={{ borderTop: '1px solid #eee' }}>
                <td colSpan="6">
                    <div className="card card-body">
                        {!state.syncAudienceDetailsLoading[audience.audienceId] &&
                            state.syncAudienceDetails &&
                            state.syncAudienceDetails[audience.audienceId] &&
                            state.syncAudienceDetails[audience.audienceId].length == 0 && <span>No import found!</span>}
                        {state.syncAudienceDetailsLoading[audience.audienceId] &&
                            state.syncAudienceDetails &&
                            state.syncAudienceDetails[audience.audienceId] &&
                            state.syncAudienceDetails[audience.audienceId].length == 0 && <span>Loading...</span>}
                        {state.syncAudienceDetails[audience.audienceId] && state.syncAudienceDetails[audience.audienceId].length > 0 && (
                            <span>
                                {/*
                            <LicenseList
                                licenses={state.syncAudienceDetails[audience.audienceId]}
                                onSortChange={sortField => onSortDetailsChange(sortField, audience.audienceId)}
                                onShowEdit={false}
                            />
                            */}

                                <table className="segment-list segment-list--table">
                                    <thead>
                                        <tr className="audience-list audience-list--header">
                                            <th className="audience-list audience-list--audience pointer" style={{ width: '150px' }}>
                                                Transaction Id
                                            </th>

                                            <th className="audience-list audience-list--creation pointer">Last Updated</th>
                                            <th className="audience-list audience-list--creation">Matchrate</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {state.syncAudienceDetails[audience.audienceId].map(event => {
                                            const totalSync = event.syncOk + event.syncError;
                                            const matchrate = getPercentage(
                                              (event.syncOk /
                                                (event.executionType === "STEP_FUNCTION"
                                                  ? totalSync
                                                  : event.rows)) *
                                                100.0
                                            );
                                            return (
                                            <tr key={'row-data-' + event.txId + '-' + event.destination + "_" + event.audienceId} className={`audience-list audience-list--row`}>
                                                <td className="audience-list audience-list--audience">
                                                    <a href={'/imports?transactionId=' + event.txId}>{event.txId}</a>
                                                </td>

                                                <td className="audience-list audience-list--creation">
                                                    {event.updated != 0 && <span>{new Date(event.updated).toLocaleString()}</span>}
                                                    {event.updated == 0 && <span>{new Date(event.creation).toLocaleString()}</span>}
                                                </td>

                                                <td className="audience-list audience-list--creation">
                                                    {event.syncOk > 0 && (
                                                        <div className="row">
                                                            <div className="col" style={{ cursor: 'pointer' }}>
                                                                <ReactTooltip
                                                                    id={'destinationDmpTooltip' + event.txId + '-' + event.destination + '_0'}
                                                                    type="dark"
                                                                    effect="solid">
                                                                    <h3>
                                                                        Marketplace: {event.destination === 'ar' ? 'Audiencerate' : getDmp(event.destination)}
                                                                    </h3>
                                                                    <div>
                                                                        IDs found in Matchtable: {numberWithCommas(event.rowsMatched)} of{' '}
                                                                        {numberWithCommas(event.rows)}
                                                                    </div>
                                                                    <div>
                                                                        Sync OK:{" "}
                                                                        {numberWithCommas(event.syncOk)} of{" "}
                                                                        {numberWithCommas(
                                                                            event.executionType === "STEP_FUNCTION" ? totalSync : event.rowsMatched
                                                                        )}
                                                                    </div>
                                                                    <div>
                                                                        Syncs in Error:{" "}
                                                                        {numberWithCommas(event.syncError)}{" "}
                                                                        of{" "}
                                                                        {numberWithCommas(
                                                                            event.executionType === "STEP_FUNCTION" ? totalSync : event.rowsMatched
                                                                        )}
                                                                    </div>
                                                                </ReactTooltip>

                                                                <div data-tip data-for={'destinationDmpTooltip' + event.txId + '-' + event.destination + '_0'}>
                                                                    <div
                                                                        style={{
                                                                            verticalAlign: 'middle',
                                                                            marginTop: '10px'
                                                                        }}>
                                                                        <b style={{ fontWeight: 'bold' }}>
                                                                            {event.destination === 'ar' ? 'AR' : getDmp(event.destination)}
                                                                        </b>
                                                                        <p style={{ fontSize: '16px' }}>
                                                                            {matchrate}%
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        )})}
                                    </tbody>
                                </table>
                            </span>
                        )}
                    </div>
                </td>
            </tr>
        )
    }
    if (state && state.sizeDetails) {
        itemRows.push(
            <tr
                key={'size-row-expanded-' + audience.audienceId}
                className={'collapse '}
                id={'sizeDetails' + audience.audienceId}
                style={{ borderTop: '1px solid #eee' }}>
                <td colSpan="12">
                    <div id="sizedetails" className="card card-body">
                        <span>
                            <div className="row">
                                <div className="col">
                                    <h3>Size Progression in the last month</h3>
                                </div>
                                {/*state.sizeDetails && state.sizeDetails[audience.audienceId] && (
                                    <div className="col-2 text-right">
                                        <DMPFilter showProducts="false" showLabels="false" onDmpChange={onDmpChange} />
                                    </div>
                                )*/}
                            </div>

                            {!state.sizeDetailsLoading[audience.audienceId] &&
                                state.sizeDetails &&
                                state.sizeDetails[audience.audienceId] &&
                                state.sizeDetails[audience.audienceId].length == 0 && <span>No size found!</span>}
                            {state.sizeDetailsLoading[audience.audienceId] &&
                                state.sizeDetails &&
                                state.sizeDetails[audience.audienceId] &&
                                state.sizeDetails[audience.audienceId].length == 0 && <span>Loading...</span>}
                            {state.sizeDetails[audience.audienceId] && state.sizeDetails[audience.audienceId].length > 0 && (
                                <span>
                                    <HighchartsReact highcharts={Highcharts} options={state.sizeChartOptions[audience.audienceId]} />
                                </span>
                            )}
                        </span>
                    </div>
                </td>
            </tr>
        )
    }
    return itemRows
}

const drawAllItemRows = (
    allItemRows,
    audiences,
    state,
    history,
    showEdit,
    showSelect,
    onSelect,
    onEdit,
    onImport,
    onHistory,
    onDelete,
    onLicenseDetail,
    onSizeDetail,
    onDmpChange,
    onRequeue,
    onSortDetailsChange
) => {
    allItemRows = []
    audiences.map((audience, index) => {
        const perItemRows = renderItem(
            audience,
            index,
            state,
            history,
            showEdit,
            showSelect,
            onSelect,
            onEdit,
            onImport,
            onHistory,
            onDelete,
            onLicenseDetail,
            onSizeDetail,
            onDmpChange,
            onRequeue,
            onSortDetailsChange
        )
        allItemRows.push(perItemRows)
    })
    return allItemRows
}

export default ({
    audiences,
    state,
    history,
    onSortDetailsChange,
    loading,
    onLoadMore,
    onEdit,
    onImport,
    onHistory,
    onDelete,
    onLicenseDetail,
    onSizeDetail,
    onDmpChange,
    onSyncAudienceDetails,
    onRequeue,
    sort,
    sortOrder,
    onSortChange,
    last_page,
    onSelect,
    showEdit = true,
    showSelect = false,
    size,
    offset
}) => {
    let allItemRows = []

    return (
        <table className="license-list license-list--table">
            <TableHeader sort={sort} sortOrder={sortOrder} onSortChange={onSortChange} showEdit={showEdit} showSelect={showSelect} />
            <tbody>
                {
                    (allItemRows = drawAllItemRows(
                        allItemRows,
                        audiences,
                        state,
                        history,
                        showEdit,
                        showSelect,
                        onSelect,
                        onEdit,
                        onImport,
                        onHistory,
                        onDelete,
                        onLicenseDetail,
                        onSizeDetail,
                        onDmpChange,
                        onSyncAudienceDetails,
                        onRequeue,
                        onSortDetailsChange
                    ))
                }

                {!loading && audiences.length >= offset + size && (
                    <tr>
                        <td colSpan={8} style={{ textAlign: 'center' }}>
                            <button type="button" className="btn btn-link property-list property-list--load-more-button" onClick={onLoadMore}>
                                Load more
                            </button>
                        </td>
                    </tr>
                )}
                {loading && (
                    <tr>
                        <td colSpan={8} style={{ textAlign: 'center' }}>
                            <button type="button" className="btn btn-link property-list property-list--load-more-button" disabled>
                                Loading...
                            </button>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    )
}
